import { EditOutlined } from '@ant-design/icons'
import TextArea from 'antd/es/input/TextArea'
import {
  requestUpdateTeamActivity
} from 'app/api/team'
import { IPayloadCreateTeamActivity, ITeamActivity } from 'app/api/team/model'
import { BaseButton } from 'app/components/common/BaseButton'
import { BaseSpace } from 'app/components/common/BaseSpace'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { BaseInput } from 'app/components/common/inputs/BaseInput'
import {
  BaseModalComponent,
  IRefModal,
} from 'app/components/common/ModalComponent'
import { notificationController } from 'app/controllers/notification-controller'
import { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'

export const UpdateTeamModal = ({ team }: { team?: ITeamActivity }) => {
  const [form] = BaseForm.useForm<IPayloadCreateTeamActivity>()
  const [isLoading, setIsLoading] = useState(false)
  const modalRef = useRef<IRefModal>({})

  const openModal = () => {
    modalRef?.current?.open?.()
  }

  const handleSubmit = async (values: IPayloadCreateTeamActivity) => {
    if (!team?.id) return
    try {
      setIsLoading(true)
      const res = await requestUpdateTeamActivity({
        id: team?.id,
        name: values?.name,
        description: values?.description,
      })

      if (res) {
        modalRef?.current?.hide?.()
        notificationController.success({ message: 'Thành công!' })
        window.location.reload()
        form?.resetFields?.()
      }
    } catch (error) {
      console.log({ error })
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    form?.setFieldsValue({
      name: team?.name,
      description: team?.description,
    })
  }, [team])

  return (
    <BaseModalComponent
      titleModal={'Cập nhật đội nhóm'}
      ref={modalRef}
      handleSubmit={form?.submit}
      isLoadingConfirm={isLoading}
      buttonOpenModal={
        <BaseButton icon={<EditOutlined rev={undefined} />} onClick={openModal}>
          {'Cập nhật'}
        </BaseButton>
      }
      renderContent={
        <BaseForm form={form} onFinish={handleSubmit}>
          <BaseSpace>
            <BaseFormItem
              name={'name'}
              required
              label={'Tên đội/nhóm'}
              rules={[
                {
                  required: true,
                  message: 'Vui lòng nhập tên đội/nhóm',
                },
              ]}
            >
              <BaseInput placeholder="Nhập tên đội/nhóm" />
            </BaseFormItem>
            <BaseForm.Item label={'Mô tả đội/nhóm'} name={'description'}>
              <TextArea
                autoSize={{ minRows: 3 }}
                placeholder="Nhập mô tả đội/nhóm"
              />
            </BaseForm.Item>
          </BaseSpace>
        </BaseForm>
      }
    />
  )
}
const BaseFormItem = styled(BaseForm.Item)`
  margin-bottom: 0px;
`
